export default __webpack_public_path__ + "static/media/search_icon.5797abc9.svg";